<script lang="ts">
    import type {BasicUser} from 'typings/portaro.be.types';
    import type {CatalogInfo} from '../types';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import SutorCatalogSelector from '../components/SutorCatalogSelector.svelte';
    import ErpHeading from '../../../../erp/components/ErpHeading.svelte';

    export let user: BasicUser;
    export let catalogUrls: CatalogInfo[];

    function getGreeting() {
        const hours = new Date().getHours() + 1;

        if (hours >= 4 && hours < 12) {
            return 'Dobré ráno';
        } else if (hours >= 12 && hours < 18) {
            return 'Dobré odpoledne';
        } else {
            return 'Dobrý večer';
        }
    }
</script>

<ErpHeading>
    <h1 class="welcome-text">👋 {getGreeting()},<br>{pipe(user, loc())}</h1>

    <svelte:fragment slot="additional-content">
        <SutorCatalogSelector {catalogUrls}/>
    </svelte:fragment>
</ErpHeading>